import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import React, {useState} from "react";
import {updatePaymentMethodOfStripeCustomer} from "../api";
const CheckoutForm = ({setPaymentSuccess, stripeCustomerId}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentError, setPaymentError] = useState("");

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    setPaymentError("");

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: window.location.origin + "/pay",
      },
      redirect: "if_required",
    });
    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
      setPaymentError(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      setPaymentSuccess(result);
      const paymentMethodId = result?.paymentIntent?.payment_method;
      if(!!stripeCustomerId && !!paymentMethodId) {
        const customer = await updatePaymentMethodOfStripeCustomer(stripeCustomerId, paymentMethodId)
      }
    }
  };

  return (
    <form data-testid="checkout-form" onSubmit={handleSubmit}>
      <PaymentElement />
      <button disabled={!stripe} type="submit" data-testid="payment-submit-btn">Submit</button>
      {paymentError && <div className="payment-error" data-testid="payment-error">{paymentError}</div>}
    </form>
  );
};
export default CheckoutForm;